import React from 'react'
import useCards from '../../../hooks/useCards'

const CourseraCards = () => {
  const { homeinCards } = useCards()
  
  return (
      <>
          {homeinCards(11)}

      </>
  )
} 

export default CourseraCards